import { api } from "./client";
import type { components } from "./types";

export type Project = components["schemas"]["Project"];
export type ProjectListItem = components["schemas"]["ProjectListItem"];
export type ProjectPatch = components["schemas"]["ProjectPatch"];
export type ProjectStatus = components["schemas"]["ProjectStatus"];
export type Task = components["schemas"]["Task"];
export type TaskWithCritical = components["schemas"]["TaskWithCritical"];
export type TaskPatch = components["schemas"]["TaskPatch"];
export type TaskKind = components["schemas"]["TaskKind"];
export type TaskStatus = components["schemas"]["TaskStatus"];
export type TaskMoveRequest = components["schemas"]["TaskMoveRequest"];
export type SetTaskOvertimeRequest = components["schemas"]["SetTaskOvertimeRequest"];
export type ApprovalRecord = components["schemas"]["ApprovalRecord"];
export type TaskDependency = components["schemas"]["TaskDependency"];

export interface ListProjectsParams {
  status?: ProjectStatus | null;
  includeArchived?: boolean;
  archivedOnly?: boolean;
  limit?: number;
  offset?: number;
}

export function listProjects(params: ListProjectsParams = {}): Promise<ProjectListItem[]> {
  const qs = new URLSearchParams();
  if (params.status) qs.set("status", params.status);
  if (params.includeArchived) qs.set("include_archived", "true");
  if (params.archivedOnly) qs.set("archived_only", "true");
  if (params.limit !== undefined) qs.set("limit", String(params.limit));
  if (params.offset !== undefined) qs.set("offset", String(params.offset));
  const tail = qs.toString();
  return api.get<ProjectListItem[]>(`/projects${tail ? `?${tail}` : ""}`);
}

export function getProject(projectId: number): Promise<ProjectListItem> {
  return api.get<ProjectListItem>(`/projects/${projectId}`);
}

export function patchProject(projectId: number, body: ProjectPatch): Promise<Project> {
  return api.patch<Project>(`/projects/${projectId}`, body);
}

export function archiveProject(projectId: number): Promise<ProjectListItem> {
  return api.post<ProjectListItem>(`/projects/${projectId}/archive`);
}

export function unarchiveProject(projectId: number): Promise<ProjectListItem> {
  return api.post<ProjectListItem>(`/projects/${projectId}/unarchive`);
}

export function deleteProject(projectId: number): Promise<void> {
  return api.delete<void>(`/projects/${projectId}`);
}

export function listProjectTasks(projectId: number): Promise<TaskWithCritical[]> {
  return api.get<TaskWithCritical[]>(`/projects/${projectId}/tasks`);
}

export function listProjectDependencies(projectId: number): Promise<TaskDependency[]> {
  return api.get<TaskDependency[]>(`/projects/${projectId}/dependencies`);
}

export function patchTask(taskId: number, body: TaskPatch): Promise<Task> {
  return api.patch<Task>(`/tasks/${taskId}`, body);
}

export function simulateTaskMove(body: TaskMoveRequest): Promise<ApprovalRecord> {
  return api.post<ApprovalRecord>(`/simulate/task_move`, body);
}

export function simulateSetTaskOvertime(body: SetTaskOvertimeRequest): Promise<ApprovalRecord> {
  return api.post<ApprovalRecord>(`/simulate/set_task_overtime`, body);
}
